<template>
  <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"400px"'
    :cpntTitulo='"Criar vínculo entre contatos"'

    :cpntOnFecharDialog='conVinculoFormFechar'>
    <template slot='conteudo'>
      <div class="con-vin-form">
        <App-Autocompletar :data-time="time" :class="campos.id_res.class"
          :cpntStatus='campos.id_res.status'
          :cpntId='campos.id_res.id'
          :cpntTabIndex='campos.id_res.tabIndex'
          :cpntNome='campos.id_res.nome'
          :cpntValue='campos.id_res.value'
          :cpntMensagem='campos.id_res.mensagem'
          :cpntMensagemTipo='campos.id_res.mensagemTipo'
          :cpntDisabled='campos.id_res.disabled'
          :cpntMostrar='campos.id_res.mostrar'
          :cpntExplica='campos.id_res.explica'
          :cpntPlaceholder='campos.id_res.placeholder'
          :cpntValueRef='campos.id_res.valueRef'
          :cpntRouter='campos.id_res.router'
          :cpntMethod='campos.id_res.method'
          :cpntField='campos.id_res.field'
          :cpntWhere='campos.id_res.where'
          :cpntAddButForm='campos.id_res.addButForm'
          :cpntKeyMostra='campos.id_res.keyMostra'
          :cpntTipoOrder='campos.id_res.tipoOrder'
          :cpntOrder='campos.id_res.order'
          :cpntOptions='campos.id_res.options'
          :cpntKeyValue='campos.id_res.keyValue'
          :cpntSearchMinimo='campos.id_res.searchMinimo'
          :cpntMask='campos.id_res.mask'
          :cpntOptionInicialNome='campos.id_res.optionInicialNome'
          :cpntOptionInicialValue='campos.id_res.optionInicialValue'
          :cpntNewOption='campos.id_res.newOption'

          :cpntOnChange='(value) => { campos.id_res.onChange(value, "id_res") }'
          :cpntOnBlur='campos.id_res.onBlur'
          :cpntOnRealizaBusca='campos.id_res.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.id_res.onKeyPressEnter'
          ref="id_res"
        ></App-Autocompletar>

        <App-Select :data-time="time" :class="campos.vinculo.class"
          :cpntStatus='campos.vinculo.status'
          :cpntId='campos.vinculo.id'
          :cpntTabIndex='campos.vinculo.tabIndex'
          :cpntNome='campos.vinculo.nome'
          :cpntValue='campos.vinculo.value'
          :cpntMensagem='campos.vinculo.mensagem'
          :cpntMensagemTipo='campos.vinculo.mensagemTipo'
          :cpntDisabled='campos.vinculo.disabled'
          :cpntMostrar='campos.vinculo.mostrar'
          :cpntExplica='campos.vinculo.explica'
          :cpntPlaceholder='campos.vinculo.placeholder'
          :cpntValueRef='campos.vinculo.valueRef'
          :cpntRouter='campos.vinculo.router'
          :cpntMethod='campos.vinculo.method'
          :cpntField='campos.vinculo.field'
          :cpntWhere='campos.vinculo.where'
          :cpntAddButForm='campos.vinculo.addButForm'
          :cpntKeyMostra='campos.vinculo.keyMostra'
          :cpntTipoOrder='campos.vinculo.tipoOrder'
          :cpntOrder='campos.vinculo.order'
          :cpntOptions='campos.vinculo.options'
          :cpntKeyValue='campos.vinculo.keyValue'
          :cpntSearchMinimo='campos.vinculo.searchMinimo'
          :cpntMask='campos.vinculo.mask'
          :cpntOptionInicialNome='campos.vinculo.optionInicialNome'
          :cpntOptionInicialValue='campos.vinculo.optionInicialValue'
          
          :cpntOnBuscarOptions='campos.vinculo.onBuscarOptions'
          :cpntOnChange='(value) => { campos.vinculo.onChange(value, "vinculo") }'
          :cpntOnBlur='campos.vinculo.onBlur'
          :cpntOnRealizaBusca='campos.vinculo.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.vinculo.onKeyPressEnter'
          ref="vinculo"
        ></App-Select>

        <App-Autocompletar :data-time="time" :class="campos.id_dep.class"
          :cpntStatus='campos.id_dep.status'
          :cpntId='campos.id_dep.id'
          :cpntTabIndex='campos.id_dep.tabIndex'
          :cpntNome='campos.id_dep.nome'
          :cpntValue='campos.id_dep.value'
          :cpntMensagem='campos.id_dep.mensagem'
          :cpntMensagemTipo='campos.id_dep.mensagemTipo'
          :cpntDisabled='campos.id_dep.disabled'
          :cpntMostrar='campos.id_dep.mostrar'
          :cpntExplica='campos.id_dep.explica'
          :cpntPlaceholder='campos.id_dep.placeholder'
          :cpntValueRef='campos.id_dep.valueRef'
          :cpntRouter='campos.id_dep.router'
          :cpntMethod='campos.id_dep.method'
          :cpntField='campos.id_dep.field'
          :cpntWhere='campos.id_dep.where'
          :cpntAddButForm='campos.id_dep.addButForm'
          :cpntKeyMostra='campos.id_dep.keyMostra'
          :cpntTipoOrder='campos.id_dep.tipoOrder'
          :cpntOrder='campos.id_dep.order'
          :cpntOptions='campos.id_dep.options'
          :cpntKeyValue='campos.id_dep.keyValue'
          :cpntSearchMinimo='campos.id_dep.searchMinimo'
          :cpntMask='campos.id_dep.mask'
          :cpntOptionInicialNome='campos.id_dep.optionInicialNome'
          :cpntOptionInicialValue='campos.id_dep.optionInicialValue'
          :cpntNewOption='campos.id_dep.newOption'

          :cpntOnChange='(value) => { campos.id_dep.onChange(value, "id_dep") }'
          :cpntOnBlur='campos.id_dep.onBlur'
          :cpntOnRealizaBusca='campos.id_dep.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.id_dep.onKeyPressEnter'
          ref="id_dep"
        ></App-Autocompletar>
      </div>
    </template>

    <template slot='rodape'>
      <div class="con-vin-form-botoes">
        <App-Button
          :cpntStatus='botoes.cancelar.status' 
          :cpntId='botoes.cancelar.id' 
          :cpntTexto='botoes.cancelar.texto' 
          :cpntClass='botoes.cancelar.class'
          :cpntMostrar='botoes.salvar.mostrar'
          :cpntTabIndex='botoes.cancelar.tabIndex'
          @onClick='botoes.cancelar.onClick'
        ></App-Button>

        <App-Button
          :cpntStatus='botoes.salvar.status' 
          :cpntId='botoes.salvar.id' 
          :cpntTexto='botoes.salvar.texto' 
          :cpntClass='botoes.salvar.class'
          :cpntMostrar='botoes.salvar.mostrar'
          :cpntTabIndex='botoes.salvar.tabIndex'
          @onClick='botoes.salvar.onClick'
        ></App-Button>
      </div>
    </template>
  </RF-Dialog>
</template>

<style>
.con-vin-form {
  width: 100%;
  padding-top: 15px;
  text-align: left;
}
  .con-vin-form > div {
    width: 100%;
  }
  .con-vin-form > div:not(:last-child) {
    padding-bottom: 22px;
  }

.con-vin-form-botoes {
  text-align: right;
}
  .con-vin-form-botoes > button:not(:first-child) {
    margin-left: 5px;
  }
</style>

<script>
  export default {
    props: {
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return () => {}
        }
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        campos: {
          id_res: {
            status: '',
            nome: 'Responsável',
            router: '/contato/get',
            method: 'POST',
            field: { id: null, nome: null, empresa: null, cnpj_cpf: null },
            where: { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] },
            keyValue: 'id',
            keyMostra: [ 'nome', ' | ', 'empresa', ' | ', 'cnpj_cpf' ],
            newOption: {
              tipo: 'icone',
              icone: { tipo: 'ico-mais' },
              explica: { titulo: '', mensagem: 'Adicionar novo responsável' },
              class: [ 'btn', 'btn-primary', 'btn-sm' ],
              onClick: this.conVinculoFormNovoContato
            },
            mostrar: true,
            value: '',
            valueRef: '',
            apiEnv: 'id_res',
            onChange: this.conVinculoFormOnChangeValue
          },
          vinculo: {
            nome: 'Vínculo',
            apiEnv: 'id_vin',
            keyValue: 'id',
            keyMostra: [ 'responsavel' ],
            value: '',
            options: [],
            onBuscarOptions: this.conVinculoFormBuscarVinculos,
            onChange: this.conVinculoFormOnChangeValue
          },
          id_dep: {
            status: '',
            nome: 'Dependente',
            router: '/contato/get',
            method: 'POST',
            field: { id: null, nome: null, empresa: null, cnpj_cpf: null },
            where: { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] },
            keyValue: 'id',
            keyMostra: [ 'nome', ' | ', 'empresa', ' | ', 'cnpj_cpf' ],
            newOption: {
              tipo: 'icone',
              icone: { tipo: 'ico-mais' },
              explica: { titulo: '', mensagem: 'Adicionar novo dependente' },
              class: [ 'btn', 'btn-primary', 'btn-sm' ],
              onClick: this.conVinculoFormNovoContato
            },
            mostrar: true,
            value: '',
            valueRef: '',
            apiEnv: 'id_dep',
            onChange: this.conVinculoFormOnChangeValue
          }
        },
        botoes: {
          cancelar: {
            status: '',
            texto: 'Cancelar',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: true,
            onClick: () => { this.conVinculoFormFechar(false) }
          },
          salvar: {
            status: '',
            texto: 'Salvar',
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            onClick: () => { this.conVinculoFormSalvar() }
          },
        }
      }
    },
    mounted: function () {
      this.conVinculoFormIniciar()
    },
    methods: {
      conVinculoFormIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.conVinculoFormSetaStatusGeral('')

        // FAZ A BUSCA OS OPTIONS PARA O CAMPO VINCULO
        // this.conVinculoFormBuscarVinculos(() => { this.conVinculoFormSetaStatusGeral('carregando') })
      },
      conVinculoFormSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      conVinculoFormFechar: function (atualizar = false) {
        // CHAMA A FUNÇÃO PARA FECHAR O FORMULARIO
        this.cpntFecharFormulario(atualizar)

        // VERIFICA SE DEVE MUDAR A ROTA DO VUE
        if (this.$route.name === 'contato_vinculo_form') {
          this.$router.push({ name: 'contato_gere', params: {} })
        }
      },
      conVinculoFormBuscarVinculos: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVE BUSCAR
          queryGet.field = { id: null, responsavel: null, dependente: null }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/contato/vinculo/tipo/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.conVinculoFormBuscarVinculos(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.vinculo.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.$set(this.campos.vinculo, 'options', registros)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      conVinculoFormOnChangeValue: function (value, indexF) {
        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF], 'mensagem', '')

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF], 'class', '')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      conVinculoFormNovoContato: function (string) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { editar: true, tipo: 'contato', id: 0, nome: string }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar) => {
          if (atualizar === true) {
            this.vendaGerTabBuscarLinhas()
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      conVinculoFormSalvar: function () {
        // SETA OS VALORES RECEBIDOS
        this.$set(this.botoes.salvar, 'status', 'carregando')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA A FUNÇÃO PARA FINALIZAÇÃO DO PROCESSO
        const finalizacao = () => {
          // SETA OS VALORES RECEBIDOS
          this.$set(this.botoes.salvar, 'status', '')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }

        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_MONTAR_FORMDATA_API(this.campos).then((formData) => {
          this.$store.state.comunicaAPI('/contato/vinculo', 'POST', formData, (retorno) => {
            if ([ '', null, undefined ].indexOf(retorno.code) === -1 && retorno.code !== '200') {
              this.conVinculoFormTratarValidacao(retorno.message, retorno.code, finalizacao)
            } else {
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(retorno)
              
              // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
              this.conVinculoFormFechar(true, [ '', null, undefined ].indexOf(retorno.ref) === -1 && [ '', null, undefined ].indexOf(retorno.ref.id) === -1 ? retorno.ref.id : this.cpntId)
            }
          }, this.conVinculoFormSetaStatusGeral, (apiValid, apiStatus) => { this.conVinculoFormTratarValidacao(apiValid, apiStatus, finalizacao) })
        })
      },
      conVinculoFormTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
          // SETA O STATUS DE CARREGANDO DO BOTÃO
          this.botoes.salvar.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
          
          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      },
    }
  }
</script>
